import { fetchApi } from 'shared/functions';

export const changePasswordService = ({ oldPassword, newPassword }) => {
  const params = {
    method: 'PUT',
    body: JSON.stringify({ oldPassword, newPassword }),
  };

  return fetchApi('/sso/password', params);
};
